import { styled } from '@mui/material';
export var FlexFlowLayout = styled('div', {
    shouldForwardProp: function (prop) { return !['minWidth', 'gap'].includes(prop); },
})(function (_a) {
    var _b = _a.minWidth, minWidth = _b === void 0 ? '300px' : _b, _c = _a.gap, gap = _c === void 0 ? '1rem' : _c;
    return ({
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'stretch',
        '--gap': gap,
        gap: 'var(--gap)',
        '&& > *': {
            minWidth: "max(".concat(minWidth, ", calc(50% - var(--gap)))"),
            flex: '1',
        },
    });
});
